import * as React from 'react';
import { cn } from '@/lib/utils';
import helpHero from './HelpCenter/img/help-hero.svg';
import { useTranslation } from 'react-i18next';

export const Healthcheck = () => {
  const { i18n } = useTranslation();
  React.useEffect(() => {
    i18n.changeLanguage(process.env.REACT_APP_LOCALE);
  }, []);

  return (
    <div className={cn('flex h-screen w-screen items-start overflow-y-auto bg-gradient-to-b from-[#F5FBFC] to-[#ECECF9] p-12 md:items-center')}>
      <div className="mx-auto w-full max-w-[1080px]">
        <img
          src={helpHero}
          alt="imagem de status"
          className="mb-7 block w-80"
        />

        <h1 className="text-3xl font-bold text-neutral-dark">Tudo certo por aqui!</h1>
        <h2 className="mb-9 text-xl font-light text-primary-dark">O serviço está funcionando normalmente.</h2>
      </div>
    </div>
  );
};
